import React from 'react';
import ResultsPage from './ResultsPage';

const previewParticipant = {
  name: 'James',
  email: 'preview@example.com',
  consent: true
};

const previewResults = {
  topThree: [
    {
      category: 'innerCritic',
      score: 17,
      slug: 'inner-critic'
    },
    {
      category: 'achievementAddict',
      score: 15,
      slug: 'achievement-addict'
    },
    {
      category: 'captainControl',
      score: 13,
      slug: 'captain-control'
    }
  ],
  allScores: [
    {category: 'innerCritic', score: 17, slug: 'inner-critic'},
    {category: 'achievementAddict', score: 15, slug: 'achievement-addict'},
    {category: 'captainControl', score: 13, slug: 'captain-control'},
    {category: 'helicopter', score: 11, slug: 'helicopter'},
    {category: 'perfectionistPapa', score: 10, slug: 'perfectionist'},
    {category: 'busyBody', score: 9, slug: 'busy-body'},
    {category: 'mrLogic', score: 8, slug: 'mr-logic'},
    {category: 'peoplePleaser', score: 7, slug: 'people-pleaser'},
    {category: 'martyr', score: 6, slug: 'martyr'},
    {category: 'escapeArtist', score: 5, slug: 'escape-artist'}
  ]
};

const ResultsPreviewPage = () => (
  <ResultsPage
    participantData={previewParticipant}
    quizResults={previewResults}
  />
);

export default ResultsPreviewPage;